const en = {
    nav: {
        servicios: "Services",
        sobre: "About us",
        zona: "Service area",
        faq: "FAQ",
        contacto: "Contact",
        reserva: "Book a service",
        openMenu: "Open menu",
        closeMenu: "Close menu",
    },
    hero: {
        eyebrow: "Dog services · Maresme",
        l1: "Your dog's wellbeing,",
        l2: "right",
        l3: "near home.",
        sub: "Dog services across the Maresme, with personalised care, trust and a genuine love for what we do.",
        cta1: "Book a service",
        cta2: "Meet us",
        pills: ["Personalised care", "Photo updates during every service", "From Alella to Mataró"],
        cardTitle: "Maresme, Barcelona",
        cardSub: "Coast · Mountains · Mediterranean",
        imgAlt: "Mauro, Irene's French bulldog, out on an autumn walk",
    },
    marquee: { b: "Close · Professional · Mediterranean" },
    home: {
        servicesEyebrow: "Services",
        servicesTitle: "Everything your dog needs",
        servicesSub: "Walks, care, boarding and much more, always with personalised attention in your area.",
        viewAll: "See all services →",
        faqEyebrow: "Frequently asked questions",
        faqTitle: "Before you write, this might help",
        faqViewAll: "See all questions →",
    },
    services: {
        "paseos": {
            nombre: "Dog walks",
            tagline: "Sea, mountains and canine rhythm.",
            desc: "Walks along the paths, beaches and trails of the Maresme, adapted to your dog's age, energy and character.",
            incluye: [
                "Solo walk or small group",
                "Route adapted to your dog's energy and age",
                "Fresh water and shady breaks",
                "Photo summary after every walk",
            ],
            paraQuien: "For dogs who need to burn energy, socialise or simply enjoy a good walk when your day doesn't allow it.",
            duracion: "30, 60 or 90 min per walk",
            chip: "from €12",
            tarifas: [["30 min walk", "€12"], ["60 min walk", "€17"], ["90 min walk", "€24"]],
            faqs: [
                { q: "Will my dog walk alone or with other dogs?", a: "It depends on their character and what we agree at the first meet-up. Their comfort and safety always come first." },
                { q: "What if it rains or gets very hot?", a: "We adapt schedules and routes to the weather. In summer we avoid the central hours of the day." },
            ],
        },
        "dog-sitting": {
            nombre: "Dog sitting",
            tagline: "Company and care by the hour.",
            desc: "Company and care for your dog by the hour: an afternoon, an evening or that event they can't join you at.",
            incluye: [
                "Constant company and supervision for the agreed hours",
                "Walks, play and feeding following their routine",
                "Photo updates during the service",
                "At your home or at ours",
            ],
            paraQuien: "For those who need to cover specific hours: a dinner, an event, a long workday or a day trip.",
            duracion: "By the hour, as needed",
            chip: "On request",
            tarifas: null,
            faqs: [
                { q: "Is there a minimum number of hours?", a: "We work with flexible blocks. Tell us about your case and we'll figure it out together." },
            ],
        },
        "cuidado-a-domicilio": {
            nombre: "In-home care",
            tagline: "Your dog, their home, their routine.",
            desc: "We come to your home while you're away, so your dog keeps their habits in the environment they know best.",
            incluye: [
                "Care at your home during your absence",
                "Walks, food, water and play following their routine",
                "Medication administration if needed",
                "Daily updates with photos and news",
            ],
            paraQuien: "For dogs who get stressed away from home, seniors, or homes where routine is everything.",
            duracion: "From one day to long stays",
            chip: "On request",
            tarifas: null,
            faqs: [
                { q: "Do you stay overnight or do drop-in visits?", a: "Both options are possible depending on what your dog needs. We define it together before booking." },
            ],
        },
        "guarderia": {
            nombre: "Day care",
            tagline: "Their day, well spent.",
            desc: "Daytime care with play, rest and walks, so your dog isn't alone all day while you work.",
            incluye: [
                "Full daytime care and company",
                "Walks and supervised play time",
                "Rest moments in a calm environment",
                "End-of-day summary with photos",
            ],
            paraQuien: "For sociable dogs who spend many hours alone during the week and need activity and company.",
            duracion: "Half day or full day",
            chip: "from €22/day",
            tarifas: [["Day care", "€22/day"], ["Premium day care", "€28/day"]],
            faqs: [
                { q: "How many dogs are there at once?", a: "We work with very small groups to guarantee real attention for every dog." },
                { q: "What does premium day care include?", a: "A day with extra attention: more walks, one-to-one play and additional cuddles. Ask us for details." },
            ],
        },
        "alojamiento": {
            nombre: "Boarding",
            tagline: "A home when you're away.",
            desc: "Your dog stays in a homely environment, cage-free, with the attention and affection of a family home.",
            incluye: [
                "Stay in a family setting, cage-free",
                "Daily walks included",
                "Feeding and rest routine respected",
                "Photos and updates every day",
            ],
            paraQuien: "For holidays, work trips or any absence where you want your dog to feel at home.",
            duracion: "Per night, weekends or long stays",
            chip: "from €29/night",
            tarifas: [["Boarding", "€29/night"], ["Premium boarding", "€35/night"]],
            faqs: [
                { q: "Can I see the place before booking?", a: "Yes. Before any stay we arrange a meet-up so we can get to know each other and answer your questions." },
            ],
        },
        "visitas-a-domicilio": {
            nombre: "Home visits",
            tagline: "A visit just when they need it.",
            desc: "One-off visits to your home for feeding, fresh water, a short walk or medication.",
            incluye: [
                "Food, fresh water and environment check",
                "Short walk or play time",
                "Medication administration if needed",
                "Photo confirmation after every visit",
            ],
            paraQuien: "For puppies who can't hold on for many hours yet, senior dogs or tricky one-off days.",
            duracion: "30 or 60 min visits",
            chip: "from €16",
            tarifas: [["30 min visit", "€16"], ["60 min visit", "€22"]],
            faqs: [
                { q: "How many visits per day can you do?", a: "As many as your dog needs. One to three is usual, depending on the case." },
            ],
        },
        "transporte": {
            nombre: "Pet transport",
            tagline: "We take them, safely.",
            desc: "Trips in an adapted vehicle around the Maresme: vet, groomer or any appointment you can't drive them to.",
            incluye: [
                "Vehicle conditioned for dog transport",
                "Door-to-door pick-up and drop-off",
                "Company during the appointment if needed",
                "Real-time arrival confirmation",
            ],
            paraQuien: "For those without a car, who can't leave work, or who need a one-off trip.",
            duracion: "One-off or round trips",
            chip: "from €10",
            tarifas: [["One-off trip (Dog Taxi)", "from €10"]],
            faqs: [
                { q: "Do you cover trips outside the Maresme?", a: "Our focus is the Maresme, but tell us about the trip and we'll consider it." },
            ],
        },
        "personalizado": {
            nombre: "Custom services",
            tagline: "Tell us what your dog needs.",
            desc: "Every dog is a world. If what you need doesn't fit any service, let's talk and design something tailor-made.",
            incluye: [
                "We listen to your case with no commitment",
                "A proposal adapted to your dog and your routine",
                "Combination of services if needed",
                "Clear quote before we start",
            ],
            paraQuien: "For special needs, tricky schedules or situations that require a tailor-made solution.",
            duracion: "To be defined case by case",
            chip: "On request",
            tarifas: null,
            faqs: [
                { q: "What kind of things can you consider?", a: "From support during a house move to routines for dogs with special needs. Write to us and let's talk." },
            ],
        },
    },
    detail: {
        inicio: "Home",
        servicios: "Services",
        reservar: "Book",
        incluye: "What's included",
        paraQuien: "Who it's for",
        duracion: "Duration",
        precio: "Price",
        aConsultar: "On request",
        aConsultarText: "Tell us about your case and we'll give you a clear, no-commitment quote, adapted to the service and your dog.",
        notas: ["Public holidays: +20%", "Second dog: +30–50%, depending on the service"],
        comoReservar: "How to book",
        pasos: [
            "Write to us via the form or WhatsApp telling us what you need.",
            "We arrange a first meet-up to get to know your dog, no strings attached.",
            "We confirm the service and the quote, and start whenever you like.",
        ],
        primerTitle: "First meet-up, no commitment",
        primerText: "Before any service, we meet in person. Your dog calls the shots.",
        faqTitle: "Questions about",
        hablamos: "Shall we talk about",
        hablamosText: "Tell us what your dog is like and what you need. We'll reply with a clear, no-commitment proposal.",
        enMaresme: "in the Maresme",
    },
    trust: {
        eyebrow: "Why choose us",
        title: "Trust that is proven, not promised",
        sub: "We know what it means to leave your dog in someone else's hands. That's why we work this way.",
        items: [
            { title: "Personalised attention", desc: "Few dogs at a time and care designed for each character. No production lines." },
            { title: "Updates during the service", desc: "Photos and news while we care for your dog, so you can relax too." },
            { title: "Experience with dogs", desc: "We treat every dog with the calm and respect we'd want for our own." },
            { title: "Deep Maresme knowledge", desc: "We live here: we know the trails, the summer shade and the quiet corners." },
            { title: "Clear protocols", desc: "A first meet-up, detailed information about your dog and written agreements." },
            { title: "Transparent pricing", desc: "Clear rates and a quote before we start. No surprises, no small print." },
        ],
    },
    areaHome: {
        eyebrow: "Service area",
        title: "From the Maresme, for the Maresme",
        sub: "We're not just another Barcelona company: we live and work here. We walk its trails, we know its beaches and we care for dogs from Alella to Mataró.",
        p: "If you're looking for a dog walker, carer or dog sitter in the Maresme who truly knows the area, you're in the right place.",
        cta: "See all municipalities",
    },
    map: { sea: "Mediterranean Sea", mountains: "Serralada Litoral", around: "and surroundings" },
    steps: {
        eyebrow: "How it works",
        title: "Four steps and total peace of mind",
        items: [
            { num: "01", title: "Get in touch", desc: "Fill in the form or write to us on WhatsApp telling us what your dog needs." },
            { num: "02", title: "We meet your dog", desc: "A first meet-up with no commitment, to get to know each other and understand their character and routines." },
            { num: "03", title: "We choose the right service", desc: "We propose the service and plan that fits best, with a clear quote." },
            { num: "04", title: "Your dog enjoys, you relax", desc: "We take care of everything and keep you updated with photos and news." },
        ],
    },
    testi: {
        eyebrow: "Testimonials",
        title: "What our dogs say (well, their families)",
        sub: "The first families who trust us say it better than we ever could.",
        items: [
            { text: "Leaving Yugus with Irene was the best decision. After every walk we'd get photos and a little report that made us feel we were there. You can tell she truly loves dogs.", author: "Laura", dog: "with Yugus" },
            { text: "Tina is a senior and very set in her routine, and Irene understood that from the very first meeting. Coming home to a calm, happy dog is priceless.", author: "Alba", dog: "with Tina" },
        ],
        pending: "The next testimonial could be your dog's",
    },
    faqs: [
        { q: "How do I book a service?", a: "Fill in the contact form or write to us on WhatsApp. We'll reply to meet your dog and agree on the service, with no commitment." },
        { q: "How much do the services cost?", a: "Walks from €12 (30 min), home visits from €16, day care €22/day, boarding €29/night and Dog Taxi from €10. Public holidays +20% and second dog +30–50% depending on the service. We always confirm the exact price before booking." },
        { q: "Can I cancel or change a booking?", a: "Cancellation policy being finalised. We'll publish it here as soon as it's confirmed. (editable)" },
        { q: "What happens at the first meet-up?", a: "We meet in person, your dog gets comfortable with us and we gather all the necessary information: routines, character, health and quirks. It's free and commitment-free." },
        { q: "What information do you need about my dog?", a: "Age, breed, character, feeding and walking routines, health, medication if any, sociability with other dogs and any detail you find important." },
        { q: "Which areas do you cover?", a: "The whole Maresme: Alella, El Masnou, Premià de Mar, Premià de Dalt, Vilassar de Mar, Vilassar de Dalt, Cabrils, Argentona, Mataró and surroundings. If you're nearby, ask us." },
        { q: "Are you available on weekends and public holidays?", a: "Yes, we also work weekends and public holidays (with a 20% supplement on holidays). Ask us about the dates you need." },
        { q: "Do you offer custom services?", a: "Yes. If your dog has special needs or your case doesn't fit a standard service, tell us and we'll design a tailor-made solution." },
        { q: "What if there's an emergency?", a: "At the first meet-up we collect your vet's details and an emergency contact, so we know exactly how to act if needed." },
        { q: "Do you care for dogs with special needs?", a: "Yes, we assess each case individually at the first meet-up to make sure we can offer the right care." },
    ],
    contact: {
        whatsappMsg: "Hi, I'd like some information about Maresme Dog Care's services.",
        eyebrow: "Bookings & contact",
        title: "Tell us what your dog needs",
        sub: "Fill in the form and we'll reply very soon to meet you, answer questions and prepare a no-commitment quote.",
        note: "You can also write to us directly on WhatsApp if you prefer. No commitment, and with all the calm in the world.",
        form: {
            nombre: "Your name *", nombrePh: "Jane Smith",
            email: "Email *", emailPh: "jane@email.com",
            telefono: "Phone", telefonoPh: "600 123 456",
            municipio: "Town *", municipioPh: "Choose your town", otro: "Other / nearby",
            perro: "Your dog's name *", perroPh: "Mauro",
            edad: "Your dog's age", edadPh: "3 years",
            servicio: "Service you need *", servicioPh: "Choose a service", servicioOtro: "Other / not sure yet",
            fechas: "Approximate dates", fechasPh: "12–18 August",
            mensaje: "Message", mensajePh: "Tell us what your dog is like, their routine and what you need…",
            submit: "Tell us what your dog needs",
            sending: "Sending…",
            privacy: "No commitment. We'll only use your data to reply to you.",
            toastOk: "Request sent. Thank you!",
            toastErr: "Couldn't send. Please try again or write to us on WhatsApp.",
        },
        success: {
            title: "We've received your message",
            text1: "Thanks for writing. We'll get in touch very soon to meet",
            text2: "and see what they need.",
            reset: "Send another request",
        },
    },
    contactPage: {
        whatsapp: "WhatsApp", email: "Email", instagram: "Instagram",
        zona: "Area", zonaValue: "The whole Maresme, Barcelona",
    },
    footer: {
        tagline: "Dog services in the Maresme. Close, professional and with a genuine love for what we do.",
        servicios: "Services", nosotros: "Us", legal: "Legal",
        verTodos: "See all →",
        sobre: "About us", zona: "Service area", faq: "FAQ", contacto: "Contact & bookings",
        aviso: "Legal notice", privacidad: "Privacy policy", cookies: "Cookies",
        claim: "Your dog's wellbeing, near home.",
    },
    servicesPage: {
        eyebrow: "Dog services in the Maresme",
        title: "Services designed for every dog",
        sub: "From the daily walk to boarding during your holidays. All our services start the same way: by getting to know your dog.",
        ctaEyebrow: "Shall we start?",
        ctaTitle: "Tell us what you need",
        ctaSub: "No commitment. We'll reply to meet your dog and prepare a clear quote.",
    },
    about: {
        eyebrow: "About us",
        title: "Hi, I'm Irene",
        p1a: "My name is",
        p1b: "and I've shared my life with dogs for as long as I can remember. I also volunteer at animal shelters and organise events and activities in the canine world.",
        p2: "Maresme Dog Care is born from that passion: the wish to create in this region services built on affection, experience and respect for every dog, understanding that each one has their own personality, needs and way of enjoying life.",
        p3: "I live in the Maresme and enjoy it every day: its paths among vineyards, its early-morning beaches, the hills when the heat kicks in. And almost always with Mauro, my French bulldog and adventure companion.",
        caption: "Irene and Mauro, adventure companions",
        galleryEyebrow: "Life with dogs",
        galleryTitle: "What an ordinary day looks like",
        gallery: ["Summer on the Mediterranean, with Mauro", "Autumn among the chestnut trees", "Not even snow stops us", "Mauro, always exploring"],
        blocks: [
            { title: "Our philosophy", text: "Few dogs, lots of attention. We'd rather say no than offer care that isn't excellent. Every dog is unique and deserves a plan made for them." },
            { title: "Commitment to wellbeing", text: "Your dog's wellbeing guides every decision: respected routines, adapted routes, rest when needed and constant communication with you." },
            { title: "Real-life experience", text: "Ours doesn't come from a brochure: it comes from years shared with dogs, shelter volunteering and organising canine activities. Dogs of every kind, character and energy." },
        ],
        ctaLine: "Shall we meet? The first coffee (and the first sniff) is on us.",
        cta: "Tell us what your dog needs",
    },
    areaPage: {
        eyebrow: "Service area",
        title: "Dog services in the Maresme",
        sub: "We cover the whole Maresme region, from the coast to the hills. If you live here (or have your second home here), we care for your dog near home.",
        h2: "Dog walkers and carers who know the territory",
        p1: "The Maresme isn't just where we work: it's our home. We know the Serralada Litoral trails for the most energetic dogs, the best times to hit the beach in summer and the quiet corners for those who prefer calm.",
        p2a: "If you're looking for a",
        p2b: "dog walker in the Maresme",
        p2c: "a",
        p2d: "trustworthy dog sitter",
        p2e: "or",
        p2f: "in-home dog care",
        p2g: "here we are: close by, available and with an approach that always starts by getting to know your dog.",
        municipiosTitle: "Municipalities we cover",
        line1: "Dog care in",
        other: "Live in another nearby town? Write to us: if we can get there properly, we'll be there.",
        ctaTitle: "Your dog, in good hands and near home",
        ctaSub: "Tell us which town you're in and what your dog needs. We'll reply with a no-commitment proposal.",
        cta: "Book a service",
    },
    faqPage: {
        eyebrow: "Frequently asked questions",
        title: "Questions answered, no detours",
        sub: "Bookings, prices, cancellations, first meet-ups and everything you usually wonder before trusting us with your dog.",
        noAnswer: "Can't find your answer?",
        cta: "Write to us directly",
    },
    cookie: {
        text: "We use technical and analytics cookies to improve your experience. You can accept or reject them anytime.",
        accept: "Accept",
        reject: "Reject",
        more: "Learn more",
    },
    welcome: {
        title: "So good to see you again!",
        text: "We're still here, from Alella to Mataró, for whatever your dog needs.",
        close: "Close",
    },
    legal: {
        updated: "Last updated: September 2026",
        aviso: {
            title: "Legal notice",
            sections: [
                { h: "1. Website owner", p: "In compliance with Spanish Law 34/2002 on Information Society Services and Electronic Commerce (LSSI-CE), this website is owned by Irene Infante Riol, with tax ID (NIF) 39403930P, address at Carrer Romaní 19, 08348 Cabrils (Barcelona) and contact email ireneinfanteriol@gmail.com." },
                { h: "2. Purpose", p: "This website aims to inform about the dog care and wellbeing services that Maresme Dog Care offers in the Maresme region (Barcelona), and to provide a contact channel for requesting information or quotes." },
                { h: "3. Terms of use", p: "Accessing and using this website grants the status of user and implies acceptance of this legal notice. The user agrees to make lawful, diligent and respectful use of the contents. The owner is not responsible for any misuse of the contents or any damages arising from it." },
                { h: "4. Intellectual property", p: "All contents of this website (texts, photographs, design, logo and code) are owned by Irene Infante Riol or used under licence, and are protected by intellectual property law. Reproduction, distribution or public communication without express authorisation is prohibited." },
                { h: "5. Liability and links", p: "The owner is not responsible for the contents of third-party websites linked from this page, nor guarantees the absence of errors or continuous availability of the site, although she will work to avoid and correct them." },
                { h: "6. Applicable law", p: "This legal notice is governed by Spanish law. For any dispute, the parties submit to the courts of the user's place of residence, unless applicable law provides otherwise." },
            ],
        },
        privacidad: {
            title: "Privacy policy",
            sections: [
                { h: "1. Data controller", p: "The controller of your personal data is Irene Infante Riol, with tax ID (NIF) 39403930P, address at Carrer Romaní 19, 08348 Cabrils (Barcelona) and email ireneinfanteriol@gmail.com." },
                { h: "2. Data we collect and purpose", p: "Through the contact form we collect your name, email, phone, town and the information you provide about your dog and the service you need. This data is used solely to answer your request, contact you and prepare a quote or service proposal." },
                { h: "3. Legal basis", p: "The legal basis for processing is your consent, given when submitting the form, and the application of pre-contractual measures requested by you when asking for information or a quote (art. 6.1.a and 6.1.b GDPR)." },
                { h: "4. Retention and recipients", p: "Data is kept for as long as needed to handle your request and, where applicable, the service relationship. It is not shared with third parties or used for advertising purposes. Email notifications are sent through a technical provider acting as data processor." },
                { h: "5. Your rights", p: "You can exercise your rights of access, rectification, erasure, objection, restriction and portability at any time by writing to ireneinfanteriol@gmail.com. If you believe the processing does not comply with the regulations, you can file a complaint with the Spanish Data Protection Agency (www.aepd.es)." },
                { h: "6. Security", p: "We apply appropriate technical and organisational measures to protect your personal data against unauthorised access, loss or alteration." },
            ],
        },
        cookies: {
            title: "Cookie policy",
            sections: [
                { h: "1. What cookies are", p: "Cookies are small files stored on your device when you visit a website, allowing it, among other things, to remember your preferences or analyse how the page is used." },
                { h: "2. Cookies used by this site", p: "This website uses technical cookies necessary for its proper functioning and analytics cookies that help us understand how the page is used and improve it. When you enter, you'll see a notice where you can accept or reject them; if you reject them, analytics is disabled. We do not use advertising cookies." },
                { h: "3. How to manage cookies", p: "In addition to this site's notice, you can allow, block or delete cookies from your browser settings. Please note that blocking technical cookies may affect how the website works. Check your browser's help (Chrome, Safari, Firefox, Edge) for details." },
                { h: "4. Updates", p: "This policy may be updated to reflect changes in the cookies used. For any questions, write to us at ireneinfanteriol@gmail.com." },
            ],
        },
    },
};

export default en;
